export interface IProduct {
    id?: string
    nameFr?: string
    nameEn?: string
    descriptionFr?: string
    descriptionEn?: string
    memberPrice?: number
    nonMemberPrice?: number
    cardImage?: File
    savedCardImage?: string
    cardImageEn?: File
    savedCardImageEn?: string
    membersOnly?: boolean
}

export class Product implements IProduct {
    id?: string;
    nameFr?: string
    nameEn?: string
    descriptionFr?: string
    descriptionEn?: string

    memberPrice?: number
    nonMemberPrice?: number
    cardImage?: File
    savedCardImage?: string
    cardImageEn?: File
    savedCardImageEn?: string
    membersOnly?: boolean
    accountCode?: string
    itemCode?: string
}